module.exports = __webpack_public_path__ + "static/sectionafter-b374410e544e4023aea6b47e1a223733.png";